<template>
  <v-app>
    <AppHeader />
    <div style>
      <h1 style="text-align: center;">Spot Packages</h1>
      <div style="display:flex; justify-content:center;">
        <v-card
          v-for="offer in spotOffers"
          :key="offer.id"
          style="margin:10px; "
          width="250"
          outlined
        >
          <v-card-title>
            <div style="margin: auto;">{{ offer.description }}</div>
          </v-card-title>
          <v-card-subtitle>
            <h3 style="text-align: center;">${{ offer.cost }}</h3>
            <i>Add a spot allowance to your traffic on top of what you have every month.</i>
          </v-card-subtitle>
          <v-card-text>Will be used only after your monthly allowance is depleted, Valid for 1 year</v-card-text>
          <v-card-actions>
            <v-btn @click="select(offer.id)" style="margin: auto">
              <i>buy</i>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <h1 style="text-align: center;">Subscription Packages</h1>
      <div style="display:flex; justify-content:center;">
        <v-card
          v-for="offer in subscriptionOffers"
          :key="offer.id"
          style="margin:10px; "
          width="250"
          outlined
        >
          <v-card-title>
            <div style="margin: auto;">{{ offer.description }}</div>
          </v-card-title>
          <v-card-subtitle>
            <h3 style="text-align: center;">${{ offer.cost }} per month</h3>
            <i>Increase your allowed traffic every month.</i>
          </v-card-subtitle>
          <v-card-text>Will be added to your free monthly allowance</v-card-text>
          <v-card-actions>
            <v-btn style="margin: auto">
              <i>coming soon...</i>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <div style="display:flex; justify-content:center;">
        <p>All offers are cumulative</p>
      </div>
      <div style="display:flex; justify-content:center;">
        <p>While under a paid plan ads will be removed</p>
      </div>
    </div>
  </v-app>
</template>

<script>
import * as api from "./api";
import AppHeader from "./AppHeader";

export default {
  name: "StripeView",
  components: {
    AppHeader,
  },
  props: {},
  data: () => ({
    subscriptionOffers: [
      {
        id: "500mbsub",
        description: "500 MB / M",
        cost: 1,
      },
      {
        id: "2gbsub",
        description: "2 GB / M",
        cost: 2,
      },
      {
        id: "5gbsub",
        description: "5 GB / M",
        cost: 3,
      },
    ],
    spotOffers: [
      {
        id: "1gbspot",
        description: "1 GB",
        cost: 2,
      },
      {
        id: "3gbspot",
        description: "3 GB",
        cost: 5,
      },
      {
        id: "10gbspot",
        description: "10 GB",
        cost: 10,
      },
    ],
  }),
  computed: {},
  methods: {
    async select(offer) {
      console.log(offer);
      const session = await api.createCheckoutSession(offer);
      console.log(session);
      // "pk_test_51HR6FWGKWhnqELC2qPJ3p6mASAiSXUAZqEPJBR61rln4BIqjFrOrUEXDzCqS2jjOpMlGgUBSNAJwxMJbxBiEmDpW00fa2xZggA"
      const stripe = window.Stripe(
        "pk_live_51HR6FWGKWhnqELC2A4g1niYjmaUfvq7u5T0KF77SdvdgIZ6baoYZZtfNEMy3Cq0IoJa8V1YW8X0DWqVc6pBXL5T600hTyx0z7d"
      );
      stripe.redirectToCheckout({ sessionId: session.id });
    },
  },
};
</script>
